import { TooltipProps as MuiTooltipProps, Tooltip } from '../../Tooltip';
import { IconButton, IconButtonProps } from '../IconButton';

export type IconButtonWithTooltipProps = IconButtonProps &
  Pick<MuiTooltipProps, 'title'> & {
    TooltipProps?: Omit<MuiTooltipProps, 'children' | 'title'>;
  };

export const IconButtonWithTooltip = ({ title, TooltipProps, ...iconButtonProps }: IconButtonWithTooltipProps) => (
  <Tooltip title={title} display="flex" {...TooltipProps}>
    <IconButton aria-label={title} {...iconButtonProps} />
  </Tooltip>
);
